import { yup } from '@guiker/yup-util'

export const tenantPreferenceIdNested = yup.object({
  tenantPreferenceId: yup.string().required(),
})

export type TenantPreferenceIdNested = yup.InferType<typeof tenantPreferenceIdNested>
